import { getTypedObjectKeys } from '@pkg/types';

export const tokens = {
    size: {
        min: 80,
        max: 160,
    },
    position: {
        min: -10,
        max: 110,
    },
    theme: {
        alien: ['#ffe922', '#00f2b8'],
        blood: ['#0027b0', '#f52c2c'],
        blossom: ['#dcafff', '#e77c5a'],
        dawn: ['#a94ce2', '#ffe600'],
        dusk: ['#51dfc6', '#5b167c'],
        ocean: ['#30a59e', '#4200ff'],
        sunset: ['#4ce2e2', '#ff3d00'],
        sunrise: ['#ed8cd7', '#ffb800'],
        toxic: ['#e29d4c', '#adff00'],
        twilight: ['#4c64e2', '#db00ff'],
    },
};

export const themeKeys = getTypedObjectKeys(tokens.theme);
